import gql from 'graphql-tag';

export const SEARCH_REFERENCES = gql`
  query searchReferences(
    $referenceIdList: [ReferenceQueryRequestItem]
    $locationIdList: [String]
    $paginationSize: Int
    $paginationToken: String
  ) {
    searchReferences(
      referenceIdList: $referenceIdList
      locationIdList: $locationIdList
      paginationSize: $paginationSize
      paginationToken: $paginationToken
    ) {
      receiveReferenceQueryResponseList {
        receiveReference {
          receiveReferenceId
          externalReferenceValue
          externalReferenceType
          expectedReceiveLocation
          expectedDeliveryDateTime
          supplier
          trackingId
          carrier
          siteName
          clusterName
          referenceStatus
          scannableId
        }
        scannableIdFoundAs
        status {
          validationStatusType
          statusCode
          statusMessage
        }
      }
      paginationNextToken
    }
  }
`;
